import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { UserNotificationContext } from '../components/userNotification/userNotificationContext';
import { UserNotificationType } from '../components/userNotification/userNotificationType.enum';
import { LoginDomainService } from '../pages/login/loginDomainService';
import { AuthService } from '../state/helperServices/auth/auth.service';
import { di } from '../state/inversify.config';

export const useDatastoreErrors = () => {
  const { t } = useTranslation();
  const { addUserNotification } = useContext(UserNotificationContext);

  const authService = di.get(AuthService);
  const loginDomainService = di.get(LoginDomainService);
  const dataStoreError = loginDomainService.useDataStoreErrorSelector();

  useEffect(() => {
    authService.listenToDataStoreErrors();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!dataStoreError) return;
    addUserNotification(
      UserNotificationType.ERROR,
      t(dataStoreError),
      UserNotificationType.ERROR,
    );
    loginDomainService.clearDataStoreError();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataStoreError]);
};
